import { RESET, SET_SHOW_CHILD_CARDS } from "./childCardFilter.actionTypes";

export const reset = () => (dispatch) => {
  dispatch({
    type: RESET,
  });
};

export const setShowChildCards = (data) => (dispatch) => {
  dispatch({
    type: SET_SHOW_CHILD_CARDS,
    payload: data,
  });
};
